import React, { useContext, useEffect } from 'react';
import styles from './styles.module.css';
import { fsfLogo } from 'assets/newIcons';
import MobileContext from 'context/MobileContext';

export const Header = () => {
  const isMobile = useContext(MobileContext);
  return (
    <div className={styles.container}>
      <div className={`${styles.headerContainer} ${isMobile ? styles.mob : null}`}>
        <div>
          <img
            src={fsfLogo}
            alt="logo"
            className={`${styles.logo} ${isMobile ? styles.mob : null}`}
          />
        </div>
      </div>
    </div>
  );
};
